import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusesSection } from './components/BonusesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Testimonials } from './components/Testimonials';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
type FbqFn = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[];
  push: FbqFn;
  loaded: boolean;
  version: string;
};
declare global {
  interface Window {
    fbq?: FbqFn;
    _fbq?: FbqFn;
  }
}
const PIXEL_ID = '2226605141499138';
interface AppProps {
  showPurchasePopup?: boolean;
}
export function App({
  showPurchasePopup = true
}: AppProps) {
  /* Meta Pixel Code */
  useEffect(() => {
    if (window.fbq) return;
    const n = function (...args: unknown[]) {
      if (n.callMethod) n.callMethod(...args);else n.queue.push(args);
    } as FbqFn;
    window.fbq = n;
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const first = document.getElementsByTagName('script')[0];
    first?.parentNode?.insertBefore(script, first);
    n('init', PIXEL_ID);
    n('track', 'PageView');
  }, []);
  /* End Meta Pixel Code */

  return <div className="min-h-screen w-full bg-white font-sans text-brand-navy selection:bg-brand-yellow selection:text-brand-navy" data-id="element-0" data-mp="nvj179a902mk">
      <noscript data-id="element-1" data-mp="stubfl4ggf5b">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="stcc2fmhxkt6" />
      </noscript>

      <Hero data-id="element-3" data-mp="3ucj8niqdvrog" />
      <main data-id="element-4" data-mp="3uf5hdlp0gd89">
        <ProblemSection data-id="element-5" data-mp="d4o09u01u88q" />
        <SolutionSection data-id="element-6" data-mp="d4xpvgh6mddw" />
        <BonusesSection data-id="element-7" data-mp="d45tw4joadn3" />
        <BenefitsSection data-id="element-8" data-mp="d2biphy7dzw7" />
        <OfferSection data-id="element-9" data-mp="85ul7x54696g" />
        <GuaranteeSection data-id="element-10" data-mp="86mgt7ypo6wq" />
        <Testimonials data-id="element-11" data-mp="86cmj86mvdl8" />
        <FAQSection data-id="element-12" data-mp="83qdt580as1f" />
        <FinalCTA data-id="element-13" data-mp="3gkv0trn63pda" />
      </main>
      <Footer data-id="element-14" data-mp="3gm665vw9h56i" />
      {showPurchasePopup && <PurchasePopup data-id="element-15" data-mp="3gj1s86szuv2n" />}
    </div>;
}